const serviceData = [
    {
      title: "Real Estate Investment Consultation",
      description: "Expert guidance on profitable real estate investments.",
      image: "./investment.jpg",
    },
    {
      title: "Land Acquisition & Layout Development",
      description: "Developing open plots and farmland layouts.",
      image: "./land.jpg",
    },
    {
      title: "Residential & Commercial Construction",
      description: "Building homes and commercial properties with quality.",
      image: "./construction.jpg",
    },
    {
      title: "Roads, Bridges & Infrastructure",
      description: "Expert construction of roads, bridges, dams, and tunnels.",
      image: "./road.jpg",
    },
    {
      title: "Property Rent, Lease & Resale",
      description: "Boosting property sales with strategic marketing.",
      image: "./resale.jpg",
    },
    {
      title: "Architectural & Interior Designs",
      description: "Innovative designs for homes and commercial spaces.",
      image: "./architectural_design.jpg",
    },
    {
        title: "Home Interiors, Renovations & Improvements",
        description: "Transform your living space with expert design and renovation services.",
        image: "./interior.jpg",
    },
    {
      title: "Smart Home Automation",
      description: "Integrating technology for modern smart homes.",
      image: "./smarthome.jpg",
    },
    {
      title: "Landscaping & Gardening",
      description: "Creating beautiful outdoor spaces.",
      image: "./gardening.jpg",
    },
    {
      title: "Property Management & Maintenance",
      description: "Ensuring long-term value and upkeep.",
      image: "./property.jpg",
    },
    {
      title: "Project Evaluation, Appraisal & Management",
      description: "Expert analysis to maximize project value.",
      image: "./project.jpg",
    },
    {
      title: "REITs, Property Crowdfunding & Investments",
      description: "Funding innovative real estate projects.",
      image: "./crowdfunding.jpg",
    },
    {
      title: "Loans, Insurance & Finance Support",
      description: "Financial solutions for real estate investments.",
      image: "./loans.jpg",
    },
    {
      title: "Legal & Documentation Services",
      description: "Hassle-free legal and documentation assistance.",
      image: "./legal.jpg",
    },
    {
      title: "Real Estate Education & Certification",
      description: "Learn real estate investment strategies.",
      image: "./certificate.jpg",
    },
  ];
  
  export default serviceData;
  